import { UploadedImage } from "@/src/components/uploadSpots";
import { DocumentFormat } from "@/src/data/allTypes";
import { barcode1 } from "@/src/data/data";
import { USER } from "@/src/data/globalVariables";
import { useEffect, useState } from "react";
import { HtmlDiv } from "./htmlDiv";

export function DocumentFooter({ format }: { format: DocumentFormat }) {
  let user = USER.useSubscribe(`footerUser`);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    setReload(reload + 1);
  }, [JSON.stringify(user)]);

  let service = user?.service;
  let footerType = user?.service?.footerType || "default";
  let className = `documentFooter footer-${footerType} footerTheme-${service?.theme}`;

  console.log("footerType", footerType);

  let infoChild = (
    <div>
      <div className="bold">{service?.footerH1 || ""}</div>
      <div>{service?.footerH2 || ""}</div>
      <div>{service?.footerH3 || ""}</div>
    </div>
  );

  let logoChild = (
    <div>
      {service?.footerLogo ? (
        <UploadedImage
          upload={service.footerLogo}
          style={{
            boxShadow: "none",
            background: "transparent",
            height: service.footerLogoHeight || undefined,
            width: service.footerLogoWidth || undefined,
            opacity: service.footerLogoOpacity || undefined,
            padding: service.footerLogoPadding || undefined,
          }}
        />
      ) : (
        <img src="./images/logo3.png" alt="" />
      )}
    </div>
  );

  if (service?.showFooterBarcodeInsteadOfLogo)
    logoChild = (
      <HtmlDiv
        style={{
          boxShadow: "none",
          background: "transparent",
          height: service.footerLogoHeight || undefined,
          width: service.footerLogoWidth || undefined,
          opacity: service.footerLogoOpacity || undefined,
          padding: service.footerLogoPadding || undefined,
        }}
      >
        {barcode1}
      </HtmlDiv>
    );

  if (footerType == "textRight")
    return (
      <div className={className}>
        <FooterBackground />
        {logoChild}
        <div className="tright">{infoChild}</div>
      </div>
    );

  if (footerType == "textCenter")
    return (
      <div className={className}>
        {logoChild}
        {infoChild}
      </div>
    );

  if (footerType == "textLeft")
    return (
      <div className={className}>
        <FooterBackground />
        <div className="tleft">{infoChild}</div>
        {logoChild}
      </div>
    );

  if (footerType == "empty") return <div className={className}></div>;

  // if (footerType == "default")
  //   return (
  //     <div className={className}>
  //       {logoChild}
  //       {infoChild}
  //       {logoChild}
  //     </div>
  //   );

  return <></>;
}

function FooterBackground() {
  let user = USER.useSubscribe(`footerBackground`);
  let service = user?.service;

  if (service?.theme == "curvy")
    return (
      <div className="curvyFooterBackground">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="visual"
          viewBox="0 0 900 300"
          width="900"
          height="300"
          version="1.1"
        >
          <path
            d="M0 132L37.5 137.2C75 142.3 150 152.7 225 152.8C300 153 375 143 450 136.7C525 130.3 600 127.7 675 132.2C750 136.7 825 148.3 862.5 154.2L900 160L900 301L862.5 301C825 301 750 301 675 301C600 301 525 301 450 301C375 301 300 301 225 301C150 301 75 301 37.5 301L0 301Z"
            fill="RGBA(0, 191, 255, 0.2)"
            stroke-linecap="round"
            stroke-linejoin="miter"
          />
        </svg>
      </div>
    );
  return <></>;
}
